import { useLocation } from 'react-router-dom'

/** Returns search URL param value. */
const useSearch = (): string | null => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const search = searchParams.get('search')

  return search
}

export default useSearch
